import PopupManager from './popup-manager.js';

const SignPopup = {
    init() {
        this.registerPopup('sign-in', 'in');
        // /community/ landing page — same magic-link form, but in
        // sign-up framing (creates account on first submit). The
        // hidden popup body lives in page-templates/community-landing.php
        // as #join-community-popup-content and carries
        // redirect_to=/community/ which the magic-link verification
        // handler turns into a Circle handoff.
        this.registerPopup('join-community', 'up');
    },

    registerPopup(popupType, formType) {
        PopupManager.register(popupType, {
            size: 'wide',
            bodyClasses: ['popup__body--sign'],
            skipDefaultFormInit: true,
            preserveFormIds: true,
            onOpen: (container) => {
                const form = container.querySelector('form[data-signin-form]');
                if (!form) {
                    return;
                }

                // Note: we used to manually strip the data-signin-initialized
                // attribute here so the cloned popup form (carrying the
                // attribute over from the source #join-community-popup-content
                // via innerHTML) would get its submit listener attached.
                // That logic is no longer needed: SignIn.setupForm now tracks
                // initialised forms in a WeakSet keyed by DOM identity, so a
                // freshly cloned node is always treated as uninitialised
                // regardless of any inherited attributes.

                if (!form.getAttribute('data-type')) {
                    form.setAttribute('data-type', formType);
                }

                if (!form.id) {
                    form.id = `${popupType}-form-${Date.now()}`;
                }

                const bindForm = () => {
                    if (window.SignIn && typeof window.SignIn.initForm === 'function') {
                        window.SignIn.initForm(form);
                    }
                    if (window.InputLabels && typeof window.InputLabels.init === 'function') {
                        window.InputLabels.init();
                    }
                };

                if (window.SignIn && typeof window.SignIn.initForm === 'function') {
                    bindForm();
                    return;
                }

                import(/* webpackChunkName: "auth" */ './auth.js').then((m) => {
                    if (!window.SignIn) window.SignIn = m.default;
                    bindForm();
                });
            },
        });
    },
};

export default SignPopup;

window.SignPopup = SignPopup;

